// extracted by mini-css-extract-plugin
module.exports = {"evaluationResultsContainer":"Evaluations_evaluationResultsContainer__1kmtP","state":"Evaluations_state__1earB","reproved":"Evaluations_reproved__3H1gc"};